function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "9",
  height: "5",
  viewBox: "0 0 9 5",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.178 1.558C.484.698.82 0 1.926 0h5.552c1.107 0 1.437.704.748 1.558L5.958 4.372c-.694.86-1.823.854-2.512 0L1.178 1.558z",
  fill: "currentColor",
  fillRule: "evenodd"
})));